import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_item_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  property_json?: {};
  options_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  quantity: fromDatatype.NumericDatatypeInterface;

  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code:  fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom_desc: fromDatatype.TextDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_item_line_RowClass
  implements bl_fi_mst_item_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  property_json?: {};
  options_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  quantity: fromDatatype.NumericDatatypeInterface;

  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code:  fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom_desc: fromDatatype.TextDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
}
